import { ERROR_RECOGNITION_MODE } from 'Types';
import {
  RepertoireActionTypes,
  RepertoireData,
  UserRepertoireProgress,
  UserRepertoireData,
  SetRepertoireSelectPayload,
  SetRepertoirePlayingPayload,
  SetPlaybackPhasePayload,
  SetPlaybackPhase,
  RepertoireState,
  SetCursorVisible,
  SetPlaySessionId,
  SetVerticalScroll,
  SetHorizontalScroll,
  SetPerfectPhraseEnabled,
  SetPerfectPhraseCount,
  ClearRepertoireData,
} from 'Types/RepertoireTypes';

export type RepertoireSessionPayload = {
  repertoire_id: number;
  error_recognition_mode: ERROR_RECOGNITION_MODE;
};

export type CreateRepertoireSession = {
  type: typeof RepertoireActionTypes.CREATE_REPERTOIRE_SESSION;
  payload: RepertoireSessionPayload;
};

export type CreateRepertoireSessionSuccess = {
  type: typeof RepertoireActionTypes.CREATE_REPERTOIRE_SESSION_SUCCESS;
};

export const updateRepertoireDataRequest = (payload: UserRepertoireProgress) => ({
  type: RepertoireActionTypes.UPDATE_REPERTOIRE_DATA_REQUEST,
  payload,
});

export const fetchRepertoireDataSuccess = (payload: RepertoireData[]) => ({
  type: RepertoireActionTypes.FETCH_REPERTOIRE_DATA_SUCCESS,
  payload,
});

export const setRepertoireEnded = (payload: boolean) => ({
  type: RepertoireActionTypes.SET_REPERTOIRE_ENDED,
  payload,
});

export const setRepertoireSelect = (payload: SetRepertoireSelectPayload) => ({
  type: RepertoireActionTypes.SET_REPERTOIRE_SELECT,
  payload,
});

export const createRepSession = (payload: RepertoireSessionPayload): CreateRepertoireSession => ({
  type: RepertoireActionTypes.CREATE_REPERTOIRE_SESSION,
  payload,
});

export const setPlaySessionId = (payload: string | null): SetPlaySessionId => ({
  type: RepertoireActionTypes.SET_PLAY_SESSION_ID,
  payload,
});

export const fetchURPSuccess = (payload: UserRepertoireProgress[]) => ({
  type: RepertoireActionTypes.FETCH_URP_SUCCESS,
  payload,
});

export const updateRepertoireDataLocal = (payload: Partial<UserRepertoireProgress>) => {
  return {
    type: RepertoireActionTypes.UPDATE_REPERTOIRE_DATA_LOCAL,
    payload,
  };
};

export const loadRepertoireState = (payload: RepertoireState) => ({
  type: RepertoireActionTypes.LOAD_REPERTOIRE_STATE,
  payload,
});

export const setRepertoirePlaying = (payload: SetRepertoirePlayingPayload) => ({
  type: RepertoireActionTypes.SET_REPERTOIRE_PLAYING,
  payload,
});

export const setPlaybackPhase = (payload: SetPlaybackPhasePayload): SetPlaybackPhase => ({
  type: RepertoireActionTypes.SET_PLAYBACK_PHASE,
  payload,
});

export const setCursorVisible = (payload: boolean): SetCursorVisible => ({
  type: RepertoireActionTypes.SET_CURSOR_VISIBLE,
  payload,
});

export const fetchUserRepertoireSuccess = (payload: UserRepertoireData[]) => ({
  type: RepertoireActionTypes.FETCH_USER_REPERTOIRE_SUCCESS,
  payload,
});

export const setUserRepertoireProcessing = (payload: {
  id: number;
  status: 'processing' | 'processed' | 'complete' | 'failed' | 'error';
}) => ({
  type: RepertoireActionTypes.SET_USER_REPERTOIRE_PROCESSING,
  payload,
});

export const setVerticalScroll = (payload: {
  page: 'home' | 'browse';
  position: number;
}): SetVerticalScroll => ({
  type: RepertoireActionTypes.SET_VERTICAL_SCROLL,
  payload,
});

export const setHorizontalScroll = (payload: {
  rowId: string;
  position: number;
}): SetHorizontalScroll => ({
  type: RepertoireActionTypes.SET_HORIZONTAL_SCROLL,
  payload,
});

export const setPerfectPhraseEnabled = (payload: boolean): SetPerfectPhraseEnabled => ({
  type: RepertoireActionTypes.SET_PERFECT_PHRASE_ENABLED,
  payload,
});

export const setPerfectPhraseCount = (payload: number): SetPerfectPhraseCount => ({
  type: RepertoireActionTypes.SET_PERFECT_PHRASE_COUNT,
  payload,
});

// Reset the repertoire slice to defaults on logout so one user's library and
// progress never bleeds into the next account signed in on the same session.
export const clearRepertoireData = (): ClearRepertoireData => ({
  type: RepertoireActionTypes.CLEAR_DATA,
});
